import React, { useRef, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Container,
  Typography,
  Button,
  LinearProgress,
  ImageList,
  ImageListItem,
  ImageListItemBar,
} from "@material-ui/core";
// import { color } from "html2canvas/dist/types/css/types/color";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
import { deliverablesElData, deliverablesFlashData } from "../../projectManagementQueries";




const rowImages = [
  {
    serialNumber: 'SN 20552349593549858',
    items: [
      { Flash: 'Post TC 200', imageUrl: 654736934363429 },
      { Flash: 'Post TC 400', imageUrl: 654736934363429 },
      { Flash: 'Post TC 600', imageUrl: 654736934363429 },
      { Flash: 'Post TC 800', imageUrl: 654736934363429 }
    ]
  },
  {
    serialNumber: 'SN 87457534094390',
    items: [
      { Flash: 'Post TC 200', imageUrl: 654736934363429 },
      { Flash: 'Post TC 400', imageUrl: 654736934363429 },
      { Flash: 'Post TC 600', imageUrl: 654736934363429 },
      { Flash: 'Post TC 800', imageUrl: 654736934363429 }
    ]
  },
  {
    serialNumber: 'SN 87457534094390',
    items: [
      { Flash: 'Post TC 200', imageUrl: 654736934363429 },
      { Flash: 'Post TC 400', imageUrl: 654736934363429 },
      { Flash: 'Post TC 600', imageUrl: 654736934363429 },
      { Flash: 'Post TC 800', imageUrl: 654736934363429 }
    ]
  },
  {
    serialNumber: 'SN 87457534094390',
    items: [
      { Flash: 'Post TC 200', imageUrl: 654736934363429 },
      { Flash: 'Post TC 400', imageUrl: 654736934363429 },
      { Flash: 'Post TC 600', imageUrl: 654736934363429 },
      { Flash: 'Post TC 800', imageUrl: 654736934363429 }
    ]
  }
]
const cellStyle = { border: '1px solid black' };

const Deliverables = ({ work_order, procedure_definistion }: any) => {
  const [loading, setLoading] = useState(false);


  const {
    error: errorFlashData,
    data: flashData,
    isLoading: isLoadingFlashData,
    isError: isErrorFlashData,
  } = deliverablesFlashData(work_order, procedure_definistion);


  const {
    error: errorElData,
    data: elData,
    isLoading: isLoadingElData,
    isError: isErrorElData,
  } = deliverablesElData(work_order, procedure_definistion);


  if (loading || isLoadingFlashData || isLoadingElData) {
    return (
      <div className="loader">
        <LinearProgress />
      </div>
    )
  }


  return (
    <div>
      {/* <Button onClick={handleDownloadPdf}>pdf</Button> */}



      {/* <div className="summary-report-container"> */}
      <Container>
        <Paper elevation={1}
          style={{ padding: '20px', border: '1px solid #ccc', }}
        >
         {flashData.length > 0 && (
  <>
    <div>
      <h2>Flash Data</h2>
    </div>
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      style={{ backgroundColor: '#26285c', color: 'white', fontSize: '12px', fontWeight: 'bold' }}
    >
      <Grid container item xs={4}>
        <Grid item xs={6} style={{ border: '1px solid white' }}>
          <label style={{ padding: '5px' }}>Model</label>
        </Grid>
        <Grid item xs={6} style={{ border: '1px solid white' }}>
          <label style={{ padding: '5px' }}>Serial Number</label>
        </Grid>
      </Grid>
      <Grid container item xs={4}>
        <Grid item xs={3} style={{ border: '1px solid white' }}>
          <label style={{ padding: '5px' }}>Pmax[W]</label>
        </Grid>
        <Grid item xs={2} style={{ border: '1px solid white' }}>
          <label style={{ padding: '5px' }}>Voc[V]</label>
        </Grid>
        <Grid item xs={2} style={{ border: '1px solid white' }}>
          <label style={{ padding: '5px' }}>Vmp[V]</label>
        </Grid>
        <Grid item xs={2} style={{ border: '1px solid white' }}>
          <label style={{ padding: '5px' }}>Isc[A]</label>
        </Grid>
        <Grid item xs={3} style={{ border: '1px solid white' }}>
          <label style={{ padding: '5px' }}>Imp[A]</label>
        </Grid>
      </Grid>
      <Grid container item xs={4}>
        <Grid item xs={3} style={{ border: '1px solid white' }}>
          <label style={{ padding: '5px' }}>Pmax[%]</label>
        </Grid>
        <Grid item xs={2} style={{ border: '1px solid white' }}>
          <label style={{ padding: '5px' }}>Voc[%]</label>
        </Grid>
        <Grid item xs={2} style={{ border: '1px solid white' }}>
          <label style={{ padding: '5px' }}>Vmp[%]</label>
        </Grid>
        <Grid item xs={2} style={{ border: '1px solid white' }}>
          <label style={{ padding: '5px' }}>Isc[%]</label>
        </Grid>
        <Grid item xs={3} style={{ border: '1px solid white' }}>
          <label style={{ padding: '5px' }}>Imp[%]</label>
        </Grid>
      </Grid>
    </Grid>
    {flashData.map((data: any, index: number) => (
      <React.Fragment key={index}>
        {data.const_rows.map((row: any, rowIndex: number) => (
          <Grid
            key={rowIndex}
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            style={{ backgroundColor: '#26285c', color: 'white', fontSize: '12px' }}
          >
            <Grid item xs={4} style={{ textAlign: 'center', border: '1px solid white' }}>
              <Typography>{row.test_name}</Typography>
            </Grid>
            <Grid item xs={4} style={{ textAlign: 'center', border: '1px solid white' }}>
              <Typography>Flash Data - Post {row.test_name}</Typography>
            </Grid>
            <Grid item xs={4} style={{ textAlign: 'center', border: '1px solid white' }}>
              <Typography>Percent Difference from Datasheet</Typography>
            </Grid>
            {row.flash_data.map((item: any, itemIndex: number) => (
              <Grid
                key={itemIndex}
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                style={{ color: 'black', backgroundColor: 'white', fontSize: '12px' }}
              >
                <Grid container item xs={4}>
                  <Grid item xs={6} style={{ border: '1px solid black' }}>
                    <label style={{ padding: '5px' }}>{item.model}</label>
                  </Grid>
                  <Grid item xs={6} style={{ border: '1px solid black' }}>
                    <label style={{ padding: '5px' }}>{item.serial_number}</label>
                  </Grid>
                </Grid>
                <Grid container item xs={4}>
                  <Grid item xs={3} style={{ border: '1px solid black' }}>
                    <label style={{ padding: '5px' }}>{item.Pmax}</label>
                  </Grid>
                  <Grid item xs={2} style={{ border: '1px solid black' }}>
                    <label style={{ padding: '5px' }}>{item.Voc}</label>
                  </Grid>
                  <Grid item xs={2} style={{ border: '1px solid black' }}>
                    <label style={{ padding: '5px' }}>{item.Vmp}</label>
                  </Grid>
                  <Grid item xs={2} style={{ border: '1px solid black' }}>
                    <label style={{ padding: '5px' }}>{item.Isc}</label>
                  </Grid>
                  <Grid item xs={3} style={{ border: '1px solid black' }}>
                    <label style={{ padding: '5px' }}>{item.Imp}</label>
                  </Grid>
                </Grid>
                <Grid container item xs={4}>
                  <Grid item xs={3} style={{ border: '1px solid black' }}>
                    <label style={{ padding: '5px' }}>{item.Irradiance}</label>
                  </Grid>
                  <Grid item xs={2} style={{ border: '1px solid black' }}>
                    <label style={{ padding: '5px' }}>{item.V}</label>
                  </Grid>
                  <Grid item xs={2} style={{ border: '1px solid black' }}>
                    <label style={{ padding: '5px' }}>{item.Vm}</label>
                  </Grid>
                  <Grid item xs={2} style={{ border: '1px solid black' }}>
                    <label style={{ padding: '5px' }}>{item.Is}</label>
                  </Grid>
                  <Grid item xs={3} style={{ border: '1px solid black' }}>
                    <label style={{ padding: '5px' }}>{item.Im}</label>
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Grid>
        ))}
      </React.Fragment>
    ))}
  </>
)}

{elData.length > 0 && (
  <>
    <div>
      <h2>EL Data</h2>
    </div>
    {elData.map((row: any, rowIndex: number) => (
      <Grid
        key={rowIndex}
        container
        direction="column"
        justifyContent="space-between"
        alignItems="center"
        style={{
          backgroundColor: '#26285c',
          color: 'white',
        }}
      >
        <Grid item xs={12} style={{ textAlign: 'center' }}>
          <label style={{ padding: '5px', fontWeight: 'bold', fontSize: '12px' }}>
            {row.serial_number}
          </label>
        </Grid>
        <div style={{ display: 'grid', gridAutoFlow: 'column', gap: '10px' }}>
          {row.items.map((item: any, itemIndex: number) => (
            <div key={itemIndex} style={{ textAlign: 'center' }}>
             <div>
             <label>{item.EL}</label>
              <img
                src={item.ima_url}
                loading="lazy"
                alt={item.EL}
                style={{
                  width: '150px',
                  height: 'auto',
                  marginTop: '10px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                }}
              />
            </div>
            </div>
          ))}
        </div>
      </Grid>
    ))}
  </>
)}



        </Paper>
      </Container>
      {/* </div> */}
    </div>
  );
};
const styles: Record<string, React.CSSProperties> = {
  orangeHeader: {
    backgroundColor: "#FFA500",
    fontWeight: "bold",
    textAlign: "center",
    border: "0.2px solid #000",
    padding: "2px",
    height: "40px",
    lineHeight: "22px",
    width: "auto"
  },
  orangeHeaderFooter: {
    backgroundColor: "#FFA500",
    fontWeight: "bold",
    textAlign: "center",
    border: "0.2px solid #000",
    padding: "2px",
    height: "20px",
    lineHeight: "22px",
    width: "100px"
  },
  cell: {
    padding: "5px",
    fontWeight: "bold",
    textAlign: "left",
    height: "20px",
    border: "0.2px solid #000",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: "10px",
    border: "0.2px solid #000",
  },
  formContainer: {
    backgroundColor: "#fff",
    padding: "20px",
    border: "0.2px solid #ddd",
    width: "800px",
    margin: "10px auto",
    fontSize: "11px",
  },
  header: {
    textAlign: "center",
    marginBottom: "15px",
  },
  logo: {
    height: "50px",
    marginBottom: "10px",
  },
  title: {
    fontSize: "14px",
    margin: "0",
  },
  notice: {
    fontSize: "10px",
    margin: "6px 0",
  },
  subHeading: {
    fontSize: "12px",
    margin: "6px 0",
  },
  remarks: {
    fontSize: "10px",
    marginTop: "10px",
  },
  button: {
    display: "block",
    margin: "10px auto",
    padding: "6px 10px",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
};
export default Deliverables;




